export const SURVEY_HOME_CARD_CLICKED = 'survey_home_card_clicked';
export const SURVEY_HOME_PAGE_OPEN = 'survey_home_page_open';
export const SURVEY_OPEN = 'survey_open';
export const CASHPLAY_API_LATENCY_FE = 'cashplay_api_latency_fe';
export const API_RETRIED_SUCCESS = 'api_retried_success';
